(function () {
  function getPopup() {
    return document.querySelector('.custom-cart-popup');
  }

  function showPopup() {
    const popup = getPopup();
    if (!popup) return;

    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
  }

  function hidePopup() {
    const popup = getPopup();
    if (!popup) return;

    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
  }

  function bindPopup() {
    const popup = getPopup();
    if (!popup || popup.dataset.bound === 'true') return;

    const closeBtn = popup.querySelector('.popup-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        hidePopup();
      });
    }

    popup.addEventListener('click', function (event) {
      event.stopPropagation();
    });

    popup.dataset.bound = 'true';
  }

  function openAfterAddToCart() {
    bindPopup();
    setTimeout(showPopup, 350);
  }

  document.addEventListener('DOMContentLoaded', bindPopup);
  document.addEventListener('shopify:section:load', bindPopup);
  document.addEventListener('cart:update', openAfterAddToCart);
})();
